import { c as _c } from "react/compiler-runtime";
import { Box, type BoxProps } from '@mui/material';
export function Divider(props) {
  const $ = _c(5);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      width: "45px",
      alignSelf: "stretch",
      position: "relative",
      marginLeft: "4px",
      display: {
        xs: "none",
        md: "inline-block"
      }
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      position: "absolute",
      height: "100%",
      width: "100%",
      transform: "translateZ(0)",
      willChange: "transform"
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <path d="M42.0003 0.984924C42.0003 0.984924 28.9836 3.26305 23.5003 9.11191C14.0003 19.2452 25.5937 48.3067 15.0003 60.4135C11.0003 64.9849 0.000305176 64.9849 0.000305176 64.9849C0.000305176 64.9849 11.0003 64.9849 15.0003 69.5564C25.5937 81.6631 14.0003 110.725 23.5003 120.858C28.9836 126.707 42.0003 128.985 42.0003 128.985" stroke="#C8E4FE" strokeWidth="2" />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== props) {
    t3 = <Box sx={t0}><Box component="svg" viewBox="0 0 43 130" fill="none" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none" sx={t1} {...props}>{t2}</Box></Box>;
    $[3] = props;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
}